// @ts-check

import {
  GET_INTEGRATIONS,
  UPDATE_INTEGRATION,
  GET_INTEGRATION_REFERENCES,
  DELETE_INTEGRATION
} from './actionTypes';

import { getActionStatusName } from '@/store/helpers';

export const getIntegrationsStatus = state => state.status[getActionStatusName(GET_INTEGRATIONS)] || {};
export const updateIntegrationStatus = state => state.status[getActionStatusName(UPDATE_INTEGRATION)] || {};
export const getIntegrationReferencesStatus = state => state.status[getActionStatusName(GET_INTEGRATION_REFERENCES)] || {};
export const deleteIntegrationStatus = state => state.status[getActionStatusName(DELETE_INTEGRATION)] || {};
